// Highlight search term in the text
export const highlightText = (text, term) => {
  if (!term) return text;
  const regex = new RegExp(`(${term})`, "gi");
  return text
    .split(regex)
    .map((part, index) =>
      part.toLowerCase() === term.toLowerCase() ? (
        <strong key={index}>{part}</strong>
      ) : (
        part
      )
    );
};

// Filter subpages based on the search term
export const getFilteredSubpages = (topicsData, searchTerm) => {
  const lowerCaseSearchTerm = searchTerm.toLowerCase();
  return topicsData.flatMap((topic) => {
    return topic.subpages
      .filter((subpage) =>
        subpage.title.toLowerCase().includes(lowerCaseSearchTerm)
      )
      .map((filteredSubpage) => ({
        ...filteredSubpage,
        parentTitle: topic.title,
        link: topic.link,
        subpageLink: filteredSubpage.link,
      }));
  });
};
